module.exports = __webpack_public_path__ + "img/the_ancient_ore_small_detail.c97192c7.png";